interface IProps {
  label: string
  required?: boolean,
  className?: string
  labelClassName?: string
}
export const FormLabel = ({ required, label, className, labelClassName }: IProps) => {
  return (<div className={`flex items-center gap-2 ${className}`}>
    {required && <span className="text-red-500">*</span>}
    <span className={`font-atkinsonBold font-bold text-[17px] sm:text-[21px] leading-[130%] tracking-[0.34px] sm:tracking-[0.42px] text-black ${labelClassName ?? ''}`}>{label}</span>
  </div>)
}